import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const Rebatch = () => {
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const saveDocument = utils.hooks.useSaveDocument();
  const { checkDocuments } = useCheckBeforeAction(actionType.RETURN_TO_BATCH);

  const onClick = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    if ((await saveDocument()) === null) {
      return;
    }
    dispatch(actions.modal.openModal(actionType.RETURN_TO_BATCH));
  };
  return (
    <CommonButton
      id={actionType.RETURN_TO_BATCH}
      action={onClick}
      disabled={!utils.user.isActionEnabled(records, actionType.RETURN_TO_BATCH)}
      scope="tertiary"
      value={t('rebatch')}
      customIcon="cycle-circle-flux"
    />
  );
};

export default Rebatch;
